export enum VerificationLevels {
  NOT_VERIFIED = 'Not Verified',
  BASIC = 'Basic',
  OCCASIONAL = 'Occasional',
  PRO = 'Pro',
  DECLINED = 'Declined',
}

export enum VerificationLevelStates {
  'NOT_APPROVED' = 'NotApproved',
  'IN_PROGRESS' = 'InProgress',
  'COMPLETED' = 'Completed',
}

export const defaultVerificationLimits = {
  basic: {
    fiat: { isDepositEnabled: false, isWithdrawalEnabled: false },
    crypto: { isDepositEnabled: false, isWithdrawalEnabled: false },
  },
  occasional: {
    fiat: { isDepositEnabled: false, isWithdrawalEnabled: false },
    crypto: { isDepositEnabled: false, isWithdrawalEnabled: false },
  },
  pro: {
    fiat: { isDepositEnabled: false, isWithdrawalEnabled: false },
    crypto: { isDepositEnabled: false, isWithdrawalEnabled: false },
  },
};
